import React from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import Slider from 'rc-slider';

import FormAutocomplete from 'components/forms/FormAutocomplete';

class CmsAnimationSettings extends React.Component {
  setAnimationType = animationType => {
    const { setParam } = this.props;

    setParam('animationType', animationType);
  };

  render() {
    const {
      intl: { messages },
      setParam,
      getParamValue,
    } = this.props;

    const currentAnimationType = getParamValue('animationType', 'none');
    const animationDuration = parseInt(getParamValue('animationDuration', '1000'), 10);
    const animationDelay = parseInt(getParamValue('animationDelay', '0'), 10);
    const animationIntensity = parseInt(getParamValue('animationIntensity', '50'), 10);
    const animationInitialOpacity = parseInt(getParamValue('animationInitialOpacity', '0'), 10);

    return (
      <div>
        <Row className="p-b-20">
          <Col xs={3} className="p-r-5 p-l-5 p-b-10">
            {/* none */}
            <Button
              block
              onClick={() => this.setAnimationType('none')}
              bsStyle={currentAnimationType === 'none' ? 'primary' : undefined}
            >
              {messages.none}
              <br />
              <i className="far fa-ban" />
            </Button>
          </Col>
          <Col xs={3} className="p-r-5 p-l-5 p-b-10">
            {/* fade */}
            <Button
              block
              onClick={() => this.setAnimationType('fade')}
              bsStyle={currentAnimationType === 'fade' ? 'primary' : undefined}
            >
              {messages.effect_fade}
              <br />
              <i className="far fa-adjust" />
            </Button>
          </Col>
          <Col xs={3} className="p-r-5 p-l-5 p-b-10">
            {/* slide */}
            <Button
              block
              onClick={() => this.setAnimationType('slide')}
              bsStyle={currentAnimationType === 'slide' ? 'primary' : undefined}
            >
              {messages.effect_slide}
              <br />
              <i className="fal fa-arrow-to-right" />
            </Button>
          </Col>
          <Col xs={3} class="p-r-5 p-l-5 p-b-10">
            {/* bounce */}
            <Button
              block
              onClick={() => this.setAnimationType('bounce')}
              bsStyle={currentAnimationType === 'bounce' ? 'primary' : undefined}
            >
              {messages.effect_bounce}
              <br />
              <i className="chedri-bounce" />
            </Button>
          </Col>
          <Col xs={3} className="p-r-5 p-l-5 p-b-10">
            {/* zoom */}
            <Button
              block
              onClick={() => this.setAnimationType('zoom')}
              bsStyle={currentAnimationType === 'zoom' ? 'primary' : undefined}
            >
              {messages.effect_zoom}
              <br />
              <i className="fal fa-expand-arrows" />
            </Button>
          </Col>
          <Col xs={3} className="p-r-5 p-l-5 p-b-10">
            {/* flip */}
            <Button
              block
              onClick={() => this.setAnimationType('flip')}
              bsStyle={currentAnimationType === 'flip' ? 'primary' : undefined}
            >
              {messages.effect_flip}
              <br />
              <i className="chedri-flip" />
            </Button>
          </Col>
          <Col xs={3} className="p-r-5 p-l-5 p-b-10">
            {/* fold */}
            <Button
              block
              onClick={() => this.setAnimationType('fold')}
              bsStyle={currentAnimationType === 'fold' ? 'primary' : undefined}
            >
              {messages.effect_fold}
              <br />
              <i className="chedri-fold" />
            </Button>
          </Col>
          <Col xs={3} className="p-r-5 p-l-5 p-b-10">
            {/* roll */}
            <Button
              block
              onClick={() => this.setAnimationType('roll')}
              bsStyle={currentAnimationType === 'roll' ? 'primary' : undefined}
            >
              {messages.effect_roll}
              <br />
              <i className="chedri-files-and-folders" />
            </Button>
          </Col>
        </Row>

        {currentAnimationType !== 'none' && (
          <div className="form-group-attached">
            <FormAutocomplete
              onChange={setParam}
              value={getParamValue('animationRepeat', 'once')}
              label={messages.animation_repeat}
              name="animationRepeat"
              options={[{ label: messages.repeat_once, value: 'once' }, { label: messages.repeat_loop, value: 'loop' }]}
            />

            {currentAnimationType !== 'fade' && (
              <FormAutocomplete
                onChange={setParam}
                value={getParamValue('animationDirection', 'center')}
                label={messages.animation_directiion}
                name="animationDirection"
                options={[
                  { label: messages.direction_center, value: 'center' },
                  { label: messages.direction_left, value: 'left' },
                  { label: messages.direction_right, value: 'right' },
                  { label: messages.direction_top, value: 'top' },
                  { label: messages.direction_bottom, value: 'bottom' },
                ]}
              />
            )}

            <div className="form-group form-group-default">
              <label>
                {messages.animation_duration}: {animationDuration}ms
              </label>
              <Slider
                value={animationDuration}
                min={0}
                max={2000}
                step={50}
                onChange={value => setParam('animationDuration', value)}
              />
            </div>

            <div className="form-group form-group-default">
              <label>
                {messages.animation_delay}: {animationDelay}ms
              </label>
              <Slider
                value={animationDelay}
                min={0}
                max={3000}
                step={50}
                onChange={value => setParam('animationDelay', value)}
              />
            </div>

            {currentAnimationType !== 'fade' && (
              <div className="form-group form-group-default">
                <label>
                  {messages.animation_intensity}: {animationIntensity}%
                </label>
                <Slider
                  value={animationIntensity}
                  min={0}
                  max={100}
                  step={1}
                  onChange={value => setParam('animationIntensity', value)}
                />
              </div>
            )}

            <div className="form-group form-group-default">
              <label>
                {messages.animation_initial_opacity}: {animationInitialOpacity}%
              </label>
              <Slider
                value={animationInitialOpacity}
                min={0}
                max={100}
                step={1}
                onChange={value => setParam('animationInitialOpacity', value)}
              />
            </div>

            <FormAutocomplete
              onChange={setParam}
              value={getParamValue('animationSpeedCurve', 'ease-in-out')}
              label={messages.animation_speed_curve}
              name="animationSpeedCurve"
              options={[
                { label: 'Ease-In-Out', value: 'ease-in-out' },
                { label: 'Ease', value: 'ease' },
                { label: 'Ease-In', value: 'ease-in' },
                { label: 'Ease-Out', value: 'ease-out' },
                { label: 'Linear', value: 'linear' },
              ]}
            />
          </div>
        )}
      </div>
    );
  }
}

export default CmsAnimationSettings;
